module.exports = __webpack_public_path__ + "img/shortcut-booking-manual.4491d594.svg";